import { Key } from '@/enums/key';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { EShortcutGroup } from '@shared/dto/hint_shortcuts/e_shortcut_group';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { IHintShortcutData } from '@shared/dto/hint_shortcuts/i_hint_shortcut_data';
import { useTranslation } from 'react-i18next';
import { use_slice_user } from '../store/use_slices';
import { create_data_row } from './use_hints_shortcuts_data';

export function use_hints_shortcut_visibility(): IHintShortcutData {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { user_settings } = use_slice_user(['user_settings']);

  let text = t(
    user_settings.ui_hints_shortcuts_enabled
      ? i18n_base_ui.shortcut_hints.general.shortcut_hints_visibility_hide
      : i18n_base_ui.shortcut_hints.general.shortcut_hints_visibility_show,
  );

  let data_rows = [create_data_row(text, [Key.ForwardSlash])];

  return {
    data_rows,
    key: EShortcutType.SHORTCUT_HINTS_VISIBILITY,
    keys_have_same_animation_delay: false,
    group: EShortcutGroup.GENERAL,
  };
}
